
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { dateToSeconds, getOneDate, pickerOptions } from '@/utils/dateTime'
import { getAccountStatistics } from '@/api/product/productAccount'

@Component({
  name: 'statistical',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) id!: string | number
  @Prop({ required: true }) inOrOut!: any

  queryForm: any = {
    start_time: null,
    end_time: null
  }
  private date: any[] = getOneDate()
  private pickerOptions = pickerOptions
  private listLoading: boolean = false
  private list: any = []

  private jumpAddress (row) {
    window.open(
      `https://tronscan.io/#/address/${row.collect_address}/transfers`
    )
  }

  private jumpPayoutAddress (row) {
    window.open(
      `https://tronscan.io/#/address/${row.collect_address}/transfers`
    )
  }

  private hashJump (item) {
    window.open(`https://tronscan.io/#/transaction/${item}`)
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange () {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  private select () {
    this.getData()
  }
  private reset () {
    this.queryForm = {
      start_time: null,
      end_time: null
    }
    this.date = getOneDate()
    this.getData()
  }

  private async getData () {
    try {
      this.listLoading = true
      const data: any = {
        id: this.id,
        ...this.queryForm
      }
      await getAccountStatistics(data).then((res: any) => {
        this.list = res
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  mounted () {
    this.getData()
  }
}
